/// <amd-module name="Wit/WorkItemForm/Links/GitHub/Components/PullRequestLinkUpdateTime" />
import * as React from "react";
import { Ago } from "VSSUI/Ago";
import { FormatComponent } from "VSS/Platform/Components/Format/Format";
import { getDateInUserTimeZone,  tooltipTimeFormat } from "Wit/Common/DateUtils";
import { ILinkDisplayData } from "Wit/WorkItemLinksRegistration/Contracts";
import { DefaultLinkTypeUpdateDate } from "Wit/WorkItemLinksRegistration/Components/LinkTypeUpdateDate";
import * as Resources from "Wit/WorkItemForm/Resources";
import { ExternalLinkedPullRequestArtifact } from "../GitHubDataProviderContracts";
import { PullRequestLinkTarget } from "./PullRequestLinkTarget";
import { GitHubPullRequestState } from "../../Constants";

export function PullRequestLinkUpdateTime({ link }: { link: ILinkDisplayData }) {
    const pullRequest = link.additionalData?.pullRequest as ExternalLinkedPullRequestArtifact | undefined;
    if (!pullRequest?.state || !pullRequest?.numberOrSHA) {
        return <DefaultLinkTypeUpdateDate link={link} />;
    }

    const { eventDate, eventTitle } = GetLastEventDate(pullRequest, link.updateDate);

    return (
        <>
            <FormatComponent format={eventTitle}>
                <span>{pullRequest.numberOrSHA}</span>
                <Ago date={getDateInUserTimeZone(eventDate)} currentDate={getDateInUserTimeZone()} tooltipTimeFormat={tooltipTimeFormat} />
            </FormatComponent>
            <PullRequestLinkTarget link={link} className="padding-left-4" />
        </>
    );
}

function GetLastEventDate(pullRequest: ExternalLinkedPullRequestArtifact, updateDate?: Date): { eventDate?: Date, eventTitle: string } {
    switch (pullRequest.state.toLowerCase()) {
        case GitHubPullRequestState.Open:
            return { eventDate: pullRequest.createdAt ?? updateDate, eventTitle: Resources.GithubPullRequestCreatedDate };
        case GitHubPullRequestState.Closed:
            return { eventDate: pullRequest.closedAt ?? updateDate, eventTitle: Resources.GithubPullRequestClosedDate };
        case GitHubPullRequestState.Merged:
            return { eventDate: pullRequest.mergedAt ?? updateDate, eventTitle: Resources.GithubPullRequestMergedDate };
    }
    return { eventDate: updateDate, eventTitle: "#{0} " + pullRequest.state.toLowerCase() + " {1}"};
}
